<template>
    <div style='min-height:600px;'></div>
</template>

<script>
export default {
  mounted() {
      this.$router.push(this.$route.params.target);
  }
}
</script>
